var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewNoteDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L12 17.996L1.002 18C0.737486 18.0011 0.483369 17.8971 0.295486 17.7109C0.107603 17.5247 0.00132309 17.2715 0 17.007V0.993C0 0.445 0.445 0 0.993 0H17.007C17.555 0 18 0.456 18 1.002V12ZM16 2H2V16H10V11C10 10.7551 10.09 10.5187 10.2527 10.3356C10.4155 10.1526 10.6397 10.0357 10.883 10.007L11 10L16 9.999V2ZM15.171 11.999L12 12V15.169L15.171 11.999Z",
    fill: "rgba(0, 0, 0, 0.26)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNoteDisabled);
export default __webpack_public_path__ + "static/media/new_note_disabled.fcb891ac.svg";
export { ForwardRef as ReactComponent };